import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const ITServices = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my it services business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps it services businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for it services businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most it services businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my it services business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like it services. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for IT Services - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "IT Services CRM", url: "/industries/it-services" }
  ];

  const industryData = {
    name: 'IT Services & Support',
    title: 'Capture Emergency IT Calls & Build Managed Service Contracts',
    subtitle: 'Never miss urgent tech emergencies, automate client onboarding, and convert break-fix to recurring MSP revenue',
    icon: '💻',
    challenges: [
      'Missing emergency IT calls',
      'Break-fix revenue is unpredictable',
      'Hard to convert to managed services',
      'Client onboarding is time-consuming',
      'Difficult to track billable hours'
    ],
    solutions: [
      'Emergency ticket routing 24/7',
      'Break-fix to MSP conversion campaigns',
      'Automated client onboarding',
      'Time tracking integration',
      'Proactive maintenance automation'
    ],
    features: [
      'Emergency call/ticket capture',
      'Client portal access',
      'MSP contract management',
      'Automated onboarding workflows',
      'Time and billing tracking',
      'Proactive maintenance alerts',
      'Remote support integration',
      'Review automation'
    ],
    results: [
      '70% break-fix convert to MSP',
      'Predictable recurring revenue',
      '50% faster onboarding',
      '£11.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for IT Services UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for it services businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for it services UK, it services business software, it services customer management, it services lead generation UK"
        url="/industries/it-services"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default ITServices;